import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../services/API";

export const getPrivateHas = createAsyncThunk("getPrivateHas",
    async () => {
        try {
            const response = await axiosInstance.get(`/post/has-pin/`);
            const result = response.data;
            return result;
        } catch (error) {
            return error.response.data;
        }
    }
);

export const createPin = createAsyncThunk("createPin", async (data) => {
    try {
        const response = await axiosInstance.post(`/post/set-pin/`, data);
        const result = response.data;
        return result;
    } catch (error) {
        return error.response.data;
    }
});

export const deletePrivatePin = createAsyncThunk("deletePrivatePin", async (data) => {
    try {
        const response = await axiosInstance.delete(`/post/delete-pin/`, { data });
        const result = response.data;
        return result;
    } catch (error) {

        return error.response.data;
    }
});

export const getVerifyPin = createAsyncThunk("getVerifyPin", async (data) => {
    try {
        const response = await axiosInstance.get(`/post/pin/${data.userId}/private-posts/?pin=${data.pin}`);
        const result = response.data;
        return result;
    } catch (error) {
        return error.response.data;
    }
});

export const sendOtpForgotPin = createAsyncThunk("sendOtpForgotPin", async () => {
    try {
        const response = await axiosInstance.post(`/post/send-otp/`, {});
        const result = response.data;
        return result;
    } catch (error) {
        return error.response.data;
    }
});

export const verifyOtpForgotPin = createAsyncThunk("verifyOtpForgotPin", async (data) => {
    try {
        const response = await axiosInstance.post(`/post/verify-otp/`, data);
        const result = response.data;
        return result;
    } catch (error) {
        return error.response.data;
    }
});

export const setNewPrivatePin = createAsyncThunk("setNewPrivatePin", async (data) => {
    try {
        const response = await axiosInstance.post(`/post/set-new-pin/`, data);
        const result = response.data;
        return result;
    } catch (error) {
        return error.response.data;
    }
});

export const updatePrivatePin = createAsyncThunk("updatePrivatePin", async (data) => {
    try {
        const response = await axiosInstance.post(`/post/update-pin/`, data);
        const result = response.data;
        return result;
    } catch (error) {
        return error.response.data;
    }
});

export const deletePrivatePost = createAsyncThunk("deletePrivatePost", async ({ postId, pin }, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.delete(`/post/private-posts/${postId}/delete/?pin=${pin}`);
        return response.data;
    } catch (error) {
        return rejectWithValue(error.response?.data || error.message);
    }
});

export const makePrivatePostPublic = createAsyncThunk("makePrivatePostPublic", async ({ postId, pin }, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.patch(`/post/private-posts/${postId}/make-public/?pin=${pin}`);
        return response.data;
    } catch (error) {
        return rejectWithValue(error.response?.data || error.message);
    }
});

export const searchPrivatePosts = createAsyncThunk("searchPrivatePosts", async (data) => {
    try {
        const response = await axiosInstance.get(`/post/private-post-profile-search/${data.userId}/?search=${data.search}`);
        const result = response.data;
        return result;
    } catch (error) {
        return error.response.data;
    }
});

export const AccountPrivate = createSlice({
    name: "AccountPrivate",
    initialState: {
        data: null,
        hasPin: false,
        loading: false,
        error: null,
        deletePrivatePostLoading: false,
        deletePrivatePostError: null,
        makePrivatePublicLoading: false,
        makePrivatePublicError: null,
    },
    extraReducers: (builder) => {
        // createPin action promises
        builder.addCase(createPin.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(createPin.fulfilled, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
        builder.addCase(createPin.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        //check if user has pin
        builder.addCase(getPrivateHas.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(getPrivateHas.fulfilled, (state, action) => {
            state.loading = false;
            state.hasPin = action.payload;
        });
        builder.addCase(getPrivateHas.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        //check if user has pin
        builder.addCase(getVerifyPin.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(getVerifyPin.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        });
        builder.addCase(getVerifyPin.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        //check if user has pin
        builder.addCase(verifyOtpForgotPin.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(verifyOtpForgotPin.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        });
        builder.addCase(verifyOtpForgotPin.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        //check if user has pin
        builder.addCase(setNewPrivatePin.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(setNewPrivatePin.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        });
        builder.addCase(setNewPrivatePin.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        //update private pin
        builder.addCase(updatePrivatePin.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(updatePrivatePin.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        });
        builder.addCase(updatePrivatePin.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        // searchPrivatePosts action promises
        builder.addCase(searchPrivatePosts.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(searchPrivatePosts.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        });
        builder.addCase(searchPrivatePosts.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        // deletePrivatePost
        builder.addCase(deletePrivatePost.pending, (state) => {
            state.deletePrivatePostLoading = true;
            state.deletePrivatePostError = null;
        });
        builder.addCase(deletePrivatePost.fulfilled, (state) => {
            state.deletePrivatePostLoading = false;
        });
        builder.addCase(deletePrivatePost.rejected, (state, action) => {
            state.deletePrivatePostLoading = false;
            state.deletePrivatePostError = action.payload;
        });

        // makePrivatePostPublic
        builder.addCase(makePrivatePostPublic.pending, (state) => {
            state.makePrivatePublicLoading = true;
            state.makePrivatePublicError = null;
        });
        builder.addCase(makePrivatePostPublic.fulfilled, (state) => {
            state.makePrivatePublicLoading = false;
        });
        builder.addCase(makePrivatePostPublic.rejected, (state, action) => {
            state.makePrivatePublicLoading = false;
            state.makePrivatePublicError = action.payload;
        });
    },
});

export default AccountPrivate.reducer;
